import { useDispatch, useSelector } from 'react-redux';
import errorSvg from 'assets/icons/error.svg';
import Alert from 'lib/Alert';
import { AlertThemeOption } from 'lib/Alert/Alert.types';
import { Store } from 'components/common/types/Store.types';
import { setCampaignViolations } from 'store/dealManagement/reducer';
import {
  CAMPAIGN_VIOLATION_ERROR_HEADER,
  CAMPAIGN_VIOLATION_LABEL,
  CAMPAIGN_VIOLATION_MULTIPLE_FOOTER,
  CAMPAIGN_VIOLATION_MULTIPLE_HEADER,
} from 'consts/campaignViolations';

const CampaignDrawerError: React.FC = () => {
  const dispatch = useDispatch();
  const campaignViolations = useSelector((state: Store) => state.dealManagement.campaignViolations);

  if (!campaignViolations.length) return null;

  const [singleViolation] = campaignViolations;

  return (
    <Alert
      dataTestId="campaign-drawer-error"
      header={CAMPAIGN_VIOLATION_ERROR_HEADER}
      theme={AlertThemeOption.PINK_RED}
      icon={errorSvg}
      iconClassName="w-5 h-5 shrink-0"
      onClose={() => dispatch(setCampaignViolations([]))}
    >
      {campaignViolations.length === 1 ? (
        <p className="body-base">{singleViolation.message}</p>
      ) : (
        <div className="body-base">
          <p>{CAMPAIGN_VIOLATION_MULTIPLE_HEADER}</p>
          <ul className="list-disc list-inside">
            {campaignViolations.map(({ type }) => (
              <li key={type}>{CAMPAIGN_VIOLATION_LABEL[type]}</li>
            ))}
          </ul>
          <p>{CAMPAIGN_VIOLATION_MULTIPLE_FOOTER}</p>
        </div>
      )}
    </Alert>
  );
};

export default CampaignDrawerError;
